import React from "react"
import { Modal, Space, Typography, Button, Alert } from "@mimber/ui-web"
import { SafetyCertificateOutlined } from "@mimber/ui-web"
import { useMFADisable } from "@mimber/client/mimber-organization"
import { message } from "@mimber/ui-web"
import { MFAStepUpGate } from "@/components/gates"
import type { DisableMFAModalProps } from "./DisableMFAModal.types"

const { Paragraph, Text } = Typography

export const DisableMFAModal: React.FunctionComponent<DisableMFAModalProps> = ({
  onSuccess,
  ...modalProps
}) => {
  let closeModal: (() => void) | undefined

  const mutation = useMFADisable({
    onSuccess: () => {
      closeModal?.()
      message.success("MFA has been disabled")
      onSuccess?.()
    },
    onError: (error) => {
      message.error(error.message || "Failed to disable MFA")
    },
  })

  return (
    <Modal
      title={
        <Space>
          <SafetyCertificateOutlined style={{ color: "#ff4d4f" }} />
          Disable Authenticator App
        </Space>
      }
      footer={null}
      {...modalProps}
    >
      {(close) => {
        closeModal = close
        return (
          <MFAStepUpGate>
            <Space
              orientation="vertical"
              size="large"
              style={{ width: "100%" }}
            >
              <Alert
                type="warning"
                showIcon
                title="Are you sure you want to disable MFA?"
                description="Removing your authenticator app will make your account less secure. You will only be able to sign in with your password."
              />

              <Paragraph>
                <Text strong>After disabling MFA:</Text>
                <ul style={{ marginTop: 8, paddingLeft: 20 }}>
                  <li>Your authenticator app codes will no longer work</li>
                  <li>Your account will be protected by password only</li>
                  <li>
                    You can still verify your identity via email if needed for
                    account recovery
                  </li>
                </ul>
              </Paragraph>

              <Space style={{ width: "100%", justifyContent: "flex-end" }}>
                <Button onClick={close} disabled={mutation.isPending}>
                  Cancel
                </Button>
                <Button
                  danger
                  type="primary"
                  loading={mutation.isPending}
                  onClick={() => mutation.mutate()}
                >
                  Disable MFA
                </Button>
              </Space>
            </Space>
          </MFAStepUpGate>
        )
      }}
    </Modal>
  )
}
